import * as R from 'ramda';
import { dataModel, defaults } from './dataModel';
import { widths } from '../commonDisplayOptions';

export const dividerData = { dataModel, defaults };

export const dividerDisplayOptions = {
    widths: R.values(widths)
};
